import type { Map } from "mapbox-gl";
import {
  contentType,
  ExportFieldBoundariesData,
  FarmCreate,
  FieldCreate,
  MyUser,
} from "regen-api-ts-client";

import { MAPBOX_TEST_HOOK } from "./util/constants";

export type WithTestId<P = unknown> = P & {
  "data-testid"?: string;
};

export type WithDataComponent<P = unknown> = P & {
  "data-component"?: string;
};

export type ButtonTypes = "button" | "submit" | "reset";

declare global {
  interface Window {
    [MAPBOX_TEST_HOOK]: Map | undefined;
  }
}

// Some of the autogenerated type names are not very specific, so give them
// more universal names here:
// Note: type is the union of possible values, where const is a const object
// containing keys that translate to those values (javascript enum)
export type SystemContentType = contentType;
export const SystemContentType = contentType;

// Not all 'enums' are generated as enums from the API, specifically
// ones that only occur in the request URL as path arguments.
export type BoundaryExportFormat = NonNullable<
  ExportFieldBoundariesData["path"]["format"]
>;
// and ones that are an array
export type AppRoleType = NonNullable<MyUser["roles"]>[0];
export type FarmGoal = NonNullable<FarmCreate["goals"]>[0];
export type PermissionType = NonNullable<MyUser["permissions"]["app"][0]>;
// and ones that are a union with Null
export type CashCropType = NonNullable<FieldCreate["cashCrop"]>;
